import { Alert, Link, Text } from "@amzn/storm-ui";
import * as React from "react";

import {
    CardContainer,
    DeepLinkAlertContainer,
} from "../common/styled.components";

export interface TemplateAccessDeniedAlertProps {
    onTryDifferentAccount: () => void;
}

export const TemplateAccessDeniedAlert: React.FunctionComponent<
    TemplateAccessDeniedAlertProps
> = ({ onTryDifferentAccount }) => {
    return (
        <CardContainer>
            <Alert
                variant="warning"
                header="Access Required"
                data-testid="template-access-denied"
            >
                <Text>
                    The selected Salesforce account doesn't have access to this
                    packaged insight template.
                </Text>

                <DeepLinkAlertContainer>
                    <Link onClick={onTryDifferentAccount}>
                        Try a different account
                    </Link>
                </DeepLinkAlertContainer>
            </Alert>
        </CardContainer>
    );
};
